'use strict';

import _ from 'lodash';

const Time = require('../../services/Time');
const Language = require('./../../services/Language');
const Errors = require('./../../services/Errors');
const RegexMatchVerifierContrib = require('./../contribs/RegexMatchVerifierContrib');
const Verifier = require('./../../system/Verifier');
const LruCache = require('../../classes/LruCache');

const softErrors = {
	ESERVFAIL: true,
	ECONNREFUSED: true,
	ETIMEOUT: true
};

const Email = (module.exports = Verifier.define(RegexMatchVerifierContrib, {
	type: 'EmailVerifier',

	regex: {
		VALID_CHARS: /[^\s,<>]+@[A-Z0-9\-]+\.[A-Z0-9\-\.]+/i,
		// Sendgrid seems to reject email addresses with even accented Latin characters, so restrict to printable ASCII characters
		SENDGRID_ASCII_RANGE: /^[\x20-\x7E]+$/
	},

	init_verifier: function(options) {
		this.lang = require('./EmailVerifierLang');

		this.options = _.defaults(options || {}, {
			checkForDuplicates: true,
			allowEmail: null,
			suggestLogin: false,
			subscriptionCode: null,
			required: true,
			verifyMx: true
		});

		this.required = this.options.required;
	},

	verify_duplicate: function(value) {
		if (this.options.allowEmail && this.options.allowEmail === value) {
			return true;
		}

		if (!CK.server && !this.options.allowEmail && CK.user.email() === value) {
			return true;
		}

		if (!this.options.checkForDuplicates) {
			return true;
		}

		return CK.clientSockets.users
			.emit('checkEmail', {
				email: value,
				subscriptionCode: this.options.subscriptionCode
			})
			.catch(err => {
				if (err instanceof Errors.EmailExists) {
					if (this.options.suggestLogin) {
						const Language = require('../../services/Language');
						return Language.mapVariables(this.lang.LOGIN, {
							login:
								'/login' +
								CK.fn.createQueryString({
									name: value
								})
						});
					} else {
						return this.lang.EXISTS;
					}
				}

				throw err;
			});
	},

	verify_mx: function(value) {
		if (!this.options.verifyMx) {
			return true;
		}

		if (!CK.server) {
			return true;
		}

		if (!this._mxCache) {
			this._mxCache = new LruCache(10000);
		}

		const domain = value.split('@')[1];

		return this._mxResolve(domain);
	},

	_mxResolve: function(domain) {
		const cached = this._mxCache.get(domain);

		if (cached) {
			return Promise.resolve(cached);
		}

		const dns = require('dns');

		return Promise.race([
			new Promise(fulfil => {
				dns.resolveMx(domain, (err, addresses) => {
					if (err) {
						CK.logger.debug('_mxResolve', domain, err);
					}

					const softFailure = err && softErrors[err.code];

					if (addresses) {
						fulfil(true);

						this._mxCache.put(domain, true);
					} else if (softFailure) {
						fulfil(true);
					} else {
						const invalid = {
							message: Language.mapVariables(this.lang.MX, {
								domain
							}),
							status: Verifier.STATUS.INVALID,
							tags: {
								domain,
								err,
								code: err.code,
								syscall: err.syscall,
								hostname: err.hostname
							},
							soft: true
						};

						fulfil(invalid);

						this._mxCache.put(domain, invalid);
					}
				});
			}),

			Promise.delay(3 * Time.SECOND_MS).return(true)
		]);
	}
}));

Email.INSTANCE = new Email({
	checkForDuplicates: false
});
